import React from 'react'

export const Subscribe = () => {
    return (
        // This is the subscribe form
        <form className='flex gap-3 flex-wrap justify-center items-center'>
            {/* // This is the input */}
            <input type='email' placeholder='Your email' className='w-80 h-12 text-black px-4 rounded-md border border-gray-300' />
            {/* // This is the submit button */}
            <button type='submit' className='px-10 py-3 bg-blue-500 text-xl text-white rounded-md'>Subscribe</button>
        </form>
    )
}
